/**
 * Set up routing for all Question views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import question views
import CreateQuestion from './views/CreateQuestion.js.jsx';
import QuestionList from './views/QuestionList.js.jsx';
import SingleQuestion from './views/SingleQuestion.js.jsx';
import UpdateQuestion from './views/UpdateQuestion.js.jsx';

class QuestionRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <Route exact path="/questions" component={QuestionList} />
        <YTRoute login={true} exact path="/questions/new" component={CreateQuestion} />
        <Route exact path="/questions/:questionId" component={SingleQuestion}/>
        <YTRoute login={true} exact path="/questions/:questionId/update" component={UpdateQuestion}/>
      </Switch>
    )
  }
}

export default QuestionRouter;



// WEBPACK FOOTER //
// modules/question/QuestionRouter.js.jsx